
import { useParams } from "react-router";

import { useBlocsByIdQuery } from "../../stores/OkOkStore";
import BlocsEditForm from "../../components/Blocs/BlocsEditForm";
import { useTrads } from "../../contexts/trads/useTrads";


function BlocsEdit(){
    const params = useParams();

    const { data: bloc, error, isLoading } = useBlocsByIdQuery(params.id??"0");
    const {translate}=useTrads();
    return (
        error ? (
            <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>
        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
        ) : bloc ? (
            <BlocsEditForm  blocParam={bloc} ></BlocsEditForm>
        ):null
    );
}
export default BlocsEdit;